/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 *
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Component } from '@angular/core';

import { ConfigService } from '../../../config/config.service';
import { UserService } from '../../../main/services';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {

    public userProfilePageUrl;
    public menuLinks;
    public megaMenuContent;
    public downloadItems;

    private megaMenuClickMode_ = false;
    private menuHideTimeout_;

    constructor(
        configService: ConfigService,
        public userService: UserService
    ) {

        this.userProfilePageUrl = configService.config.userProfilePageUrl;
        this.menuLinks = configService.config.menuLinks;
    }

    onLoginClick() {
        this.userService.login();
    }

    onLogoutClick() {
        this.userService.logout();
    }

    hideMegaMenu() {
        this.megaMenuClickMode_ = false;
        this.megaMenuContent = undefined;
    }

    onMenuItemClick(index, evt) {
        let megaMenuContent = this.menuLinks[index];

        if (this.megaMenuClickMode_ && megaMenuContent === this.megaMenuContent) {
            this.hideMegaMenu();
        } else {
            this.megaMenuContent = megaMenuContent;
            this.megaMenuClickMode_ = true;
        }

        evt.stopPropagation();
    }

    onMenuItemHover(index) {
        if (this.megaMenuClickMode_) {
            return;
        }

        this.megaMenuContent = this.menuLinks[index];
    }

    onMegaMenuHover() {
        if (this.megaMenuClickMode_) {
            return;
        }
        this.cancelMegaMenuHide_();
    }

    onMegaMenuMouseLeave() {
        if (this.megaMenuClickMode_) {
            return;
        }
        // use a timeout to avoid immediatly hiding the menu and catch when the mouse goes from the navbar to the menu
        this.menuHideTimeout_ = setTimeout(() => {
            this.megaMenuContent = undefined;
        }, 0);
    }

    private cancelMegaMenuHide_() {
        if (this.menuHideTimeout_) {
            clearTimeout(this.menuHideTimeout_);
            delete this.menuHideTimeout_;
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/components/navbar/navbar.component.ts